import React from 'react';
import i18n from '../../i18n';
import Layout from '../../components/Layout';
import Paper from "@material-ui/core/Paper/Paper";
import Toolbar from "../../components/Toolbar/Toolbar";
import {goBack} from "../../fn/navigation";
import CardContent from "@material-ui/core/CardContent/CardContent";
import ProtocolsForm from "../../components/Protocols/ProtocolsForm";

const ProtocolsCreate = ({classes, formUrl, protocol, customer, appointment, structure, redirectAfterSubmit, protocolConfig, values}) => (
    <Layout>
        <Toolbar
            disableGutters
            title={ protocol && protocol.is_correction ? i18n.get('protocols.correction_protocol') : i18n.get('protocols.new_protocol')}
            items={[
                {
                    icon: 'arrow_back',
                    text: i18n.get('schedules.back'),
                    href: redirectAfterSubmit,
                    onClick: (event) => {
                        event.preventDefault();
                        goBack(redirectAfterSubmit);
                    },
                }
            ]}
        />

        <Paper>
            <CardContent>
                <ProtocolsForm
                    formUrl={formUrl}
                    customer={customer}
                    appointment={appointment}
                    structure={structure}
                    redirectAfterSubmit={redirectAfterSubmit}
                    protocolConfig={protocolConfig}
                    // similarProtocol={similarProtocol}
                    protocol={protocol}
                    values={values}
                />
            </CardContent>
        </Paper>
    </Layout>
);

export default ProtocolsCreate;



// WEBPACK FOOTER //
// ./resources/assets/js/pages/protocols/Create.jsx